/**
 * Cryptographic utility functions.
 */

/**
 * Hash a password with a salt for use in J-PAKE protocol.
 * Creates a domain-separated hash: SHA-256("room:{salt}\x00pw:{password}")
 * @param {string} password - The password to hash
 * @param {string} salt - The salt (typically room ID)
 * @returns {Promise<Uint8Array>} The password hash as a Uint8Array
 */
export const hashPassword = async (password, salt) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(`room:${salt}\x00pw:${password}`);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return new Uint8Array(hashBuffer);
};

/**
 * Calculate the byte size of a text message when encoded as UTF-8.
 * @param {string} text - The text to measure
 * @returns {number} The size in bytes
 */
export const calculateMessageSize = (text) => {
  return new TextEncoder().encode(text).length;
};
